import { QueryKeyParam, createQueryKey } from '../../../query';

const membershipsKeys = (scopeId: QueryKeyParam) =>
  createQueryKey({
    all: ['store', scopeId, 'items', 'memberships'] as const,
    id: (itemId: QueryKeyParam) =>
      createQueryKey({
        all: ['store', scopeId, 'items', 'memberships', itemId] as const,
        detail: ['store', scopeId, 'items', 'memberships', itemId, 'detail'] as const,
      }),
  });

export { membershipsKeys };
